var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-container",on:{"click":_vm.toDetail}},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.content.image
          ? ("" + _vm.backendUrl + (_vm.content.image))
          : '/img/thumbnail/3.png',"alt":_vm.content.title ? _vm.content.title : ''}})])])}
var staticRenderFns = []

export { render, staticRenderFns }